import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import "../css/BookingDetail.css";
import rahul from "../assets/rahul.png";
import PageTitle from "./PageTitleCompoent";

export default function BookingDetail() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const handleBack = () => navigate("/booking");

  // ✅ booking data from params
  const booking = state?.booking || {};
  const type = state?.type || "";

  return (
    <div className="booking-container">
      <Sidebar />
      <div className="booking-main">
        <Header />
        <div className="booking-content">
          <div className="booking-heading-row">
            <PageTitle title="Booking Details" onBack={handleBack} />
          </div>

          <div className="booking-detail-card">
            <div className="booking-detail-content">
              <div className="booking-detail-info">
                <div className="booking-detail-avatar-wrapper">
                  <img
                    src={booking.avatar || rahul}
                    alt="avatar"
                    className="booking-detail-avatar"
                  />
                </div>

                {/* Left Section */}
                <div className="left-section">
                  <div className="detail-row">
                    <label>Name</label>
                    <span>: {booking.name || "N/A"}</span>
                  </div>
                  <div className="detail-row">
                    <label>Phone</label>
                    <span>: {booking.phone || "N/A"}</span>
                  </div>
                  <div className="detail-row-email">
                    <label>Email</label>
                    <span>: {booking.email || "N/A"}</span>
                  </div>
                  <div className="detail-row">
                    <label>Pet Name</label>
                    <span>: {booking.petName || "N/A"}</span>
                  </div>
                  <div className="detail-row">
                    <label>Pet Type</label>
                    <span>: {booking.petType || "N/A"}</span>
                  </div>
                  <div className="detail-row">
                    <label>Pet Breed</label>
                    <span>: {booking.petBreed || "N/A"}</span>
                  </div>
                  <div className="detail-row">
                    <label>Pet Gender</label>
                    <span>: {booking.petGender || "N/A"}</span>
                  </div>
                  <div className="detail-row">
                    <label>Pet D.O.B</label>
                    <span>: {booking.petDob || "N/A"}</span>
                  </div>
                  <div className="detail-row">
                    <label>Pet Age</label>
                    <span>: {booking.petAge || "N/A"}</span>
                  </div>
                  <div className="detail-row">
                    <label>Address</label>
                    <span>: {booking.address || "N/A"}</span>
                  </div>
                </div>

                {/* Right Section */}
                <div className="right-section">
                  <div className="detail-row">
                    <label>Booking Date</label>
                    <span>: {booking.datetime?.split(" - ")[0] || "N/A"}</span>
                  </div>
                  <div className="detail-row">
                    <label>Booking Time</label>
                    <span>: {booking.datetime?.split(" - ")[1] || "N/A"}</span>
                  </div>
                  <div className="detail-row">
                    <label>Amount</label>
                    <span>: ₹{booking.amount || "N/A"}</span>
                  </div>
                  <div className="detail-row">
                    <label>Service Type</label>
                    <span>: {booking.type || "N/A"}</span>
                  </div>
                  <div className="detail-row">
                    <label>Status</label>
                    <span>: {type}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Action Buttons / Status */}
            {type === "new" ? (
              <div className="booking-action-buttons">
                <button className="booking_detail_reject-btn">Reject</button>
                <button className="booking_detail_assign-btn">Assign</button>
              </div>
            ) : (
              <div className="booking-assigned-message">
                <p>Assigned to John</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
